import { FC, useEffect, useMemo } from 'react';
import { v4 } from 'uuid';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import breadcrumbsAdd from 'src/react/components/breadcrumbs/actions/add';
import breadcrumbsRemove from 'src/react/components/breadcrumbs/actions/remove';
import Crumb from 'src/react/components/breadcrumbs/types/Crumb';
import breadcrumbsUpdate from 'components/breadcrumbs/actions/update';

type BreadcrumbProps = {
  title: string;
  url?: string;
  isVisible?: boolean | number | string;
  add: (crumb: Crumb) => void;
  update: (crumb: Crumb) => void;
  remove: (id: string) => void;
};

const Breadcrumb: FC<BreadcrumbProps> = ({
  title,
  url,
  isVisible = true,
  add,
  update,
  remove,
}) => {
  if (!isVisible) {
    return null;
  }

  const id = useMemo<string>(() => v4(), []);

  const buildCrumb = () => ({
    id,
    title,
    url,
  });

  useEffect(() => {
    add(buildCrumb());

    return () => {
      remove(id);
    };
  }, [isVisible]);

  useEffect(() => {
    update(buildCrumb());
  }, [title, url]);

  return null;
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  add: breadcrumbsAdd,
  update: breadcrumbsUpdate,
  remove: breadcrumbsRemove,
}, dispatch);

export default connect(undefined, mapDispatchToProps)(Breadcrumb);
